import React from 'react';
import DocsLink from '../../../common/custom/DocsLink';
const Subscribe = () => {
  return (
    <>
      <h5>
        <b>Subscribe</b>
      </h5>
      <p>
        Enables the Subscribe component which allows you to add a Subscribe form to your web
        application.
      </p>
      <br />
      <DocsLink link="https://academy.drapcode.com/docs/app-builder/forms-component-subscriber-form/" />
    </>
  );
};

export default Subscribe;
